import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ContattiComponent } from './contatti.component';
import { ContattiListComponent } from './contatti-list/contatti-list.component';
import { ContattiDetailsComponent } from './contatti-details/contatti-details.component';
import { ContattiEditComponent } from './contatti-edit/contatti-edit.component';
import { ContattiCreateComponent } from './contatti-create/contatti-create.component';


const routes: Routes = [{
  path: '', component: ContattiComponent, children: [
    {path: 'list',
    component:ContattiListComponent
  },
    {path: 'details/:id',
    component:ContattiDetailsComponent
  },
    {path: 'edit/:id',
   component:ContattiEditComponent
  },
    {path: 'create/:id',
    component:ContattiCreateComponent
  }
  ]
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ContattiRoutingModule { }
